import { connect } from 'react-redux'
import { IStoreState } from '../../types'
import * as actions from '../../state/actions/trips'
import ManualTripNoShowModal from '../../components/trips/ManualTripNoShowModal'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const currentTripId = ownProps.match.params.tripId
  const currentTrip = state.trips.items[currentTripId]
  return {
    currentTripId,
    currentTrip,
    close: ownProps.history.goBack,
    loading: state.trips.isFetching
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    noShowTrip: async (tripId: string, comment: string): Promise<any> => {
      return await dispatch(actions.noShowTrip(tripId, comment))
    },
    getTripById: (tripId: string) => {
      return dispatch(actions.getTripById(tripId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManualTripNoShowModal)



// WEBPACK FOOTER //
// ./src/containers/trips/ManualTripNoShowModal.ts